import { render, staticRenderFns } from "./upPwd.vue?vue&type=template&id=525b3c2e&scoped=true"
import script from "./upPwd.vue?vue&type=script&lang=js"
export * from "./upPwd.vue?vue&type=script&lang=js"
import style0 from "./upPwd.vue?vue&type=style&index=0&id=525b3c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525b3c2e",
  null
  
)

export default component.exports